import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { Container, Input, Button, Spinner } from "reactstrap";
import FeatherIcon from "feather-icons-react";
import { Link, useHistory, Redirect } from "react-router-dom"
import "./penilaian-shared.css";
import apiResponse from '../../../../../services/apiResponse'
import PenialianBloc from "../Blocs/PenilaianBloc"
import moment from "moment"
import 'moment/locale/id'

// SVG ring geometry for the completion donut
const RADIUS = 26;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

class PenilaianPegawaiComponent extends Component {

  penialianBloc = new PenialianBloc()

  constructor(props) {
    super(props);

    this.state = {
      roles: [],
      period: {},
      employees_origin: [],
      employees: [],
      total_question: 0,
      complete_question: 0,
      tab_counts: {
         semua: 0,
         atasan: 0, 
         sejawat: 0,
         bawahan: 0
      },
      status_counts: {
        semua: 0, 
        sudah: 0, 
        belum: 0
      },
      tab_options: [
        { key: "semua", label: "Semua" },
        { key: "atasan", label: "Atasan" },
        { key: "sejawat", label: "Sejawat" },
        { key: "bawahan", label: "Bawahan" },
      ],
      status_options: [
        { key: "semua", label: "Semua Penilaian" },
        { key: "sudah", label: "Sudah Dinilai" },
        { key: "belum", label: "Belum Dinilai" },
      ],
      loadingContent: true,
      redirectBack: false,
      detailUuid: "",
      activeTab: "semua", // 'semua' | 'atasan' | 'sejawat'
      statusFilter: "semua", // 'semua' | 'sudah' | 'belum'
      pageSize: 10,
      searchTerm: "",
    };

    this.handleBack = this.handleBack.bind(this);
  }

  // ---------- Derived values (Svelte `$:` reactive statements) ----------
  get completionPercent() {
    return Math.round((this.state.complete_question / this.state.total_question) * 100);
  }

  get dashOffset() {
    return CIRCUMFERENCE - (this.completionPercent / 100) * CIRCUMFERENCE;
  }

  get filteredEmployees() {
    const { activeTab, statusFilter, searchTerm } = this.state;
    return this.state.employees.filter((e) => {
      const matchesTab =
        activeTab === "semua" ||
        (activeTab === "atasan" && e.relation === "atasan") ||
        (activeTab === "bawahan" && e.relation === "bawahan") ||
        (activeTab === "sejawat" && e.relation === "sejawat");
      const matchesStatus =
        statusFilter === "semua" ||
        (statusFilter === "sudah" && e.status === "selesai") ||
        (statusFilter === "belum" && e.status !== "selesai");
      const matchesSearch = e.name.toLowerCase().includes(searchTerm.toLowerCase());
      return matchesTab && matchesStatus && matchesSearch;
    });
  }

  // ---------- Actions ----------
  selectEmployee = (emp) => {
    const queryParams = new URLSearchParams(window.location.search);
    const uuid = queryParams.get('uuid')
    this.setState({
        detailUuid: `uuid=${uuid}&evaluatee_uuid=${emp.uuid}`
    })
  };

  setTab = (key) => {
    this.setState({ activeTab: key});
  };

  setStatusFilter = (key) => {
    this.setState({ statusFilter: key });
  };

  handlePageSizeChange = (e) => {
    this.setState({ pageSize: Number(e.target.value) });
  };

  handleSearchChange = (e) => {
    this.setState({ searchTerm: e.target.value });
  };

  handleBack(e) {
    this.setState({
        redirectBack: true
    })
  }

  renderHeaderCard() {

    const userdata = JSON.parse(localStorage.getItem("userdata"));
   

    return (
      <section className="pn-card-sm">
        <div className="clearfix">
           <div className="float-start">
                <h1 className="pn-title-sm">Penilaian 360</h1>
                <p className="text-muted mt-2">
                  {this.state.period?.ms360_team_work_unit_name} ({`Periode : ${moment(this.state.period.ms360_period_date_start).format('DD MMMM YYYY')} s/d ${moment(this.state.period.ms360_period_date_end).format('DD MMMM YYYY')}`})
                </p>
                <p className="pn-subtitle">
                  Berikan penilaian terhadap kompetensi rekan kerja secara objektif berdasarkan interaksi dan pengalaman kerja
                </p>
           </div>
           <div className="float-end">
              <Button type="button" onClick={this.handleBack} className="pn-btn-outline btn-danger">
                <FeatherIcon icon="arrow-left" size="16" />
                  <span className="ms-2">Kembali</span>
              </Button>
           </div>
        </div>

        <hr className="pn-divider" />

        <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }} className="pn-header-row">
          <div>
            <span
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "0.375rem",
                borderRadius: "9999px",
                backgroundColor: "#eff6ff",
                padding: "0.25rem 0.75rem",
                fontSize: "0.75rem",
                fontWeight: 500,
                color: "#2563eb",
              }}
            >
              <FeatherIcon icon="user" size="14" />
              Penilaian Anda
            </span>
            <p style={{ marginTop: "0.5rem", fontWeight: 600, color: "#0f172a", marginBottom: 0 }}>{userdata?.employee_full_name}</p>
            <p className="pn-subtitle" style={{ marginTop: 0 }}>{userdata?.employee_current_position_name}</p>
            <p className="pn-muted" style={{ fontSize: "0.75rem" }}>{userdata?.employee_current_work_unit_name}</p>
            <p style={{ marginTop: "0.4rem", color: "#0f172a" }}>{'Anda menilai sebagai:'}</p>
            { this.state.roles.map((r, index) => {
                return (
                    <span key={index} className={`d-inline badge rounded-pill bg-${r.class_name} small px-2 py-1 w-25 me-2`}>
                        {r.label}
                    </span>
                )
            }) }
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
            <div style={{ textAlign: "right" }}>
              <p style={{ fontSize: "1.5rem", fontWeight: 700, color: "#0f172a", margin: 0 }}>
                {this.state.complete_question}
                <span style={{ fontSize: "1rem", fontWeight: 400, color: "#94a3b8" }}>/{this.state.total_question}</span>
              </p>
              <p className="pn-muted" style={{ fontSize: "0.75rem", margin: 0 }}>Selesai</p>
            </div>
            <svg height="64" width="64" viewBox="0 0 64 64" style={{ transform: "rotate(-90deg)" }}>
              <circle cx="32" cy="32" r={RADIUS} fill="none" stroke="#e2e8f0" strokeWidth="6" />
              <circle
                cx="32"
                cy="32"
                r={RADIUS}
                fill="none"
                stroke="#2563eb"
                strokeWidth="6"
                strokeLinecap="round"
                strokeDasharray={CIRCUMFERENCE}
                strokeDashoffset={this.dashOffset}
              />
            </svg>
            <span className="sr-only">{this.completionPercent}%</span>
          </div>
        </div>

        <div className="pn-progress-thin" style={{ marginTop: "1rem" }}>
          <div className="pn-progress-fill" style={{ width: `${this.completionPercent}%` }} />
        </div>

        <p style={{ marginTop: "0.75rem", fontSize: "0.875rem", color: "#2563eb" }}>
          {this.state.total_question - this.state.complete_question} kuisioner penilaian menunggu pengisian Anda (
          {this.state.tab_counts.atasan} Atasan, {this.state.tab_counts.sejawat} Sejawat, dan {this.state.tab_counts.bawahan} Bawahan)
        </p>

        <div className="pn-badge-info" style={{ marginTop: "0.75rem" }}>
          <FeatherIcon icon="shield" size="16" style={{ marginTop: "0.125rem", flexShrink: 0, color: "#f59e0b" }} />
          <p style={{ fontSize: "0.8rem", color: "#92400e", margin: 0 }}>
            <span style={{ fontWeight: 600 }}>Prinsip Kerahasiaan:</span> Penilaian ini dilakukan secara anonim.
            Identitas Anda tidak akan ditampilkan kepada siapapun. Berikan umpan balik secara objektif dan jujur.
          </p>
        </div>
      </section>
    );
  }

  checkDraft = (member_uuid) => {
     const storageKey = `session-${member_uuid}`;
     return localStorage.getItem(storageKey) !== null
  }

  renderFilters() {
    const { activeTab, statusFilter, pageSize, searchTerm } = this.state;

    return (
      <>
        <div style={{ display: "flex", flexDirection: "column", gap: "0.75rem" }} className="pn-filters-row">
          <div style={{ display: "flex", flexWrap: "wrap", gap: "0.5rem" }}>
            {this.state.tab_options.map((tab) => (
              <>
                { parseInt(this.state.tab_counts[tab.key]) > 0 ? <>
                    <button
                      key={tab.key}
                      type="button"
                      onClick={() => this.setTab(tab.key)}
                      className={`pn-chip ${activeTab === tab.key ? "pn-chip-active" : "pn-chip-inactive"}`}
                    >
                      {tab.label}
                      <span className={activeTab === tab.key ? "pn-chip-count-on" : "pn-chip-count-off"}>
                        {this.state.tab_counts[tab.key]}
                      </span>
                    </button>
                </> : <></> }
              </>
            ))}
          </div>

          <div style={{ display: "flex", flexWrap: "wrap", gap: "0.5rem" }}>
            {this.state.status_options.map((opt) => (
              <button
                key={opt.key}
                type="button"
                onClick={() => this.setStatusFilter(opt.key)}
                className={`pn-status-chip ${statusFilter === opt.key ? "pn-status-chip-active" : ""}`}
              >
                {opt.label}
                <span style={{ fontWeight: 600 }}>{this.state.status_counts[opt.key]}</span>
              </button>
            ))}
          </div>
        </div>

        <div style={{ marginTop: "1rem", display: "flex", flexDirection: "column", gap: "0.75rem" }} className="pn-filters-row-2">
          <label style={{ display: "flex", alignItems: "center", gap: "0.5rem", fontSize: "0.875rem", color: "#64748b" }}>
            Tampilkan
            <Input
              type="select"
              bsSize="sm"
              value={pageSize}
              onChange={this.handlePageSizeChange}
              style={{ width: "auto" }}
            >
              <option value={10}>10</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
            </Input>
            Data
          </label>

          <div style={{ position: "relative" }} className="pn-search-wrap">
            <FeatherIcon
              icon="search"
              size="16"
              style={{ position: "absolute", left: "0.75rem", top: "50%", transform: "translateY(-50%)", color: "#94a3b8", pointerEvents: "none" }}
            />
            <Input
              type="text"
              placeholder="Cari berdasarkan nama pegawai..."
              value={searchTerm}
              onChange={this.handleSearchChange}
              style={{ paddingLeft: "2.25rem" }}
            />
          </div>
        </div>

        <p className="pn-muted" style={{ marginTop: "0.75rem", fontSize: "0.75rem" }}>
          Menampilkan 1 sampai {Math.min(pageSize, this.filteredEmployees.length)} dari {this.state.employees.length} data pegawai yang perlu
          dilakukan penilaian
        </p>
      </>
    );
  }

  renderResultBadge(emp) {
    if (emp.status === "selesai") {
      return (
        <span className="pn-result-badge pn-result-done">
          <FeatherIcon icon="check" size="14" />
          Selesai
        </span>
      );
    }
    if (emp.status === "draft") {
      return (
        <>
          <span className="pn-result-badge pn-result-draft">
            <FeatherIcon icon="file-text" size="14" />
            Draft Tersimpan
          </span>
          <span className="pn-result-badge pn-result-pending">Belum Dinilai</span>
        </>
      );
    }
    return <span className="pn-result-badge pn-result-pending">Belum Dinilai</span>;
  }

  renderEmployeeList() {
    return (
      <ul style={{ marginTop: "0.75rem", display: "flex", flexDirection: "column", gap: "0.625rem", listStyle: "none", paddingLeft: 0 }}>
        {this.filteredEmployees.map((emp, index) => (
          <li key={`${index}-${emp.relation}`}>
            <button
              type="button"
              onClick={() => this.selectEmployee(emp)}
              className={`pn-employee-btn ${emp.status === "selesai" ? "pn-employee-btn-done" : ""}`}
            >

              

              <span className={`pn-employee-status-icon ${emp.status === "selesai" ? "pn-employee-status-icon-done" : ""}`}>
                <FeatherIcon icon={emp.status === "selesai" ? "check" : "clock"} size="16" />
              </span>

              <span style={{ minWidth: 0, flex: "1 1 auto" }}>
                <span className="pn-employee-name">{emp.name}</span>
                <span className="pn-employee-position">{emp.position}</span>
              </span>

              <span className="pn-relation">
                <FeatherIcon icon="users" size="14" />
                <span className={emp.relation === "Atasan" ? "pn-relation-atasan" : ""}>{emp.relation}</span>
              </span>

              <>
                { this.checkDraft(emp.member_uuid) ? <>
                      <span className="pn-result-badge pn-result-draft">
                        <FeatherIcon icon="file-text" size="14" />
                        Draft Tersimpan
                      </span>
                </> : <>
                     {this.renderResultBadge(emp)}
                </> }
              </>

             

              <FeatherIcon icon="chevron-right" size="16" style={{ flexShrink: 0, color: "#cbd5e1" }} />
            </button>
          </li>
        ))}
      </ul>
    );
  }

  loadData = async () => {
    const userdata = JSON.parse(localStorage.getItem("userdata"));
    const queryParams = new URLSearchParams(window.location.search);
    const uuid = queryParams.get('uuid')
    await this.penialianBloc.fetchPenilaianDetail({ uuid: uuid, employee_uuid: userdata?.employee_uuid, work_unit_uuid: userdata?.employee_current_work_unit_uuid });
  }

  componentDidMount() {

      this.loadData()

      this.penialianBloc.penilaianDetailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingContent: false
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        loadingContent: true
                    })
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    this.setState({
                        loadingContent: false,
                        period: response.period,
                        employees_origin: response.employees,
                        employees: response.employees,
                        total_question: response.total_question,
                        complete_question: response.complete_question,
                        tab_counts: response.tab_counts,
                        status_counts: response.status_counts,
                        roles: response.roles
                    })
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

  }

  componentWillUnmount(){
     this.penialianBloc.penilaianDetailChannel.unsubscribe()
  }

  render() {
    return (
      <Fragment>
        { this.state.loadingContent ? <>
          <div className='card'>
              <div className='card-body p-5 text-center'>
                  <Spinner size="sm" className="me-1" />
                  Memuat Data...
              </div>
          </div>
        </> : <>
          <div className="pn-page">
                <Container fluid className="pn-stack" style={{ maxWidth: "100%" }}>
                {this.renderHeaderCard()}

                <section className="pn-card-sm">
                    {this.renderFilters()}
                    {this.renderEmployeeList()}
                </section>
                </Container>

                <style>{`
                @media (min-width: 640px) {
                    .pn-header-row { flex-direction: row !important; align-items: center; justify-content: space-between; }
                    .pn-filters-row { flex-direction: row !important; align-items: center; justify-content: space-between; }
                }
                @media (min-width: 1024px) {
                    .pn-filters-row { flex-direction: row !important; }
                }
                @media (min-width: 640px) {
                    .pn-filters-row-2 { flex-direction: row !important; align-items: center; justify-content: space-between; }
                    .pn-search-wrap { width: 18rem; }
                }
                `}</style>
          </div>
        </> }
        { this.state.detailUuid ?
            <Redirect to={`/kepegawaian/penialian360.html?section=assessment&${this.state.detailUuid}`} />
        : null }
        { this.state.redirectBack ?
            <Redirect to={`/kepegawaian/penialian360.html`} />
        : null }
      </Fragment>
    );
  }
}

export default PenilaianPegawaiComponent;